import { Button, Grid, Typography } from "@mui/material"
import { ModalComponent } from "../../../../../../../components/modal"
import animationBusinessAnalysis from "../../../../../../../assets/animation/Sandy Loading.json"

import Lottie from "react-lottie"
import { useNavigate } from "react-router-dom";

interface Props {
    open: boolean,
    onClose: () => void,
}

const referAndWinOptions = {
    loop: true,
    autoplay: true,
    animationData: animationBusinessAnalysis,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
    },
};

export const ModalOfflineNotice = ({
    onClose,
    open,
}: Props) => {
    const navigate = useNavigate()
    const handleClose = () => {
        onClose()
        navigate("/")

    }

    return (
        <ModalComponent
            open={open}
            withoutHeader
            onClose={handleClose}
        >
            <Grid
                width={"100%"}
                display={"flex"}
                direction={"column"}
                gap={"1.7rem"}
                alignItems={"center"}
            >
                <Typography textAlign={"center"} fontSize={"1.6rem"} fontWeight={700}>Para atender devidamente às novas resoluções do Banco Central do Brasil, estamos parametrizando o nosso sistema.</Typography>

                <Typography textAlign={"center"} fontSize={"1.6rem"} fontWeight={700}> Durante esse período não estaremos analisando novos pedidos de empréstimos.</Typography>

                <div style={{ width: "15rem", height: 'auto', marginBottom: "-2rem" }}>
                    <Lottie options={referAndWinOptions} />
                </div>

                <Button
                    variant="contained"
                    sx={{
                        width: "100%",
                        maxWidth: "27.5rem",
                        height: "4rem",
                    }}
                    onClick={handleClose}
                >Entendi</Button>

            </Grid>
        </ModalComponent >
    )
}